'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setup = setup;

var _hearbeat = require('./hearbeat');

var _tracking = require('./tracking');

var _getInstanceProperties = require('./getInstanceProperties');

var _getAppInfo = require('./getAppInfo');

function setup(baseUrl) {
  (0, _hearbeat.heartbeat)(baseUrl + 'api/tracking/heartbeat/');
  window.track = (0, _tracking.tracking)(baseUrl + 'api/games/tracking/');
  window.track('init', (0, _getAppInfo.getAppInfo)());
  return (0, _getInstanceProperties.getInstanceProperties)(baseUrl + 'api/games/');
}